import React from 'react'
import clsx from 'clsx'
import ToolBar from '@material-ui/core/ToolBar'
import {makeStyles} from '@material-ui/core/styles'
import SubMenuButton from './SubMenuButton'
import SelectDeptButton from './SelectDeptButton'
import useMediaQuery from '../useMediaQuery.js'

const useStyles = makeStyles(theme => ({
    paper: {
        position: 'absolute',
        top: 48,
        right: 5,
        borderRadius: '0px',
        width: '260px',
        whiteSpace: 'normal',
    },
    text: {
        color: '#FFFFFF',
        font: theme.typography.fontFamily,
        fontSize: '0.9rem',
        fontWeight: theme.typography.fontWeightMedium,
    },
    toolBar: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#025420',
        minHeight: '25px',
        transform: 'translateY(-12px)',
        transition: theme.transitions.create(['transform'], {
            duration: theme.transitions.duration.shortest,
        }),
    },
    toolBarOpen: {
        transform: 'translateY(0px)',
    },
    subMenuContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignSelf: 'start',
        margin: '1px 0 0 160px',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    subMenuButton: {
        color: theme.palette.common.white,
        margin: '0 0 0 0',
        padding: '10px 10px 0 10px',
        lineHeight: '0rem',
        boxShadow: 'none',
        height: '0.825rem',
        textTransform: 'uppercase',
        fontSize: '0.7rem',
        '&:hover': {
            boxShadow: 'none',
            opacity: 0.8,
        },
    },
    subMenuContainerMobile: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignSelf: 'start',
        margin: '1px 0 0 20%',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
}))

const SubMenu = props => {
    const classes = useStyles()
    const {branch, userrole} = props
    const isMobile = useMediaQuery('(max-width: 960px)')

    let component = null

    switch (branch) {
        case '/':
        case '/swiping':
            component = null
            /* Uncomment when implementing Kiosk mode
                (
                <div className={classes.subMenuContainer}>
                   <SubMenuButton
                        pathname={branch}
                        route={'/swiping'}
                        name={'Home'}
                    />
                    <SubMenuButton
                        pathname={branch}
                        route={'/swiping'}
                        name={'Kiosk Swiping'}
                  /> 
            </div>
            )*/
            break
        case '/eventsetup':
        case '/swipeteams':
            component = [
                'Super Admin',
                'Department Admin',
                'Department Creator',
            ].includes(userrole) ? (
                <>
                    <div className={classes.subMenuContainer}>
                        <SelectDeptButton userrole={userrole} />
                        <SubMenuButton
                            pathname={branch}
                            route={'/eventsetup'}
                            name={'Events'}
                        />
                        <SubMenuButton
                            pathname={branch}
                            route={'/swipeteams'}
                            name={'Swipe Teams'}
                        />
                    </div>
                    <div className={classes.subMenuContainerMobile}>
                        <SelectDeptButton userrole={userrole} />
                    </div>
                </>
            ) : null
            break
        case '/manageroles':
        case '/superadminroles':
        case '/auditalldeptroles':
            component = ['Super Admin', 'Department Admin'].includes(
                userrole
            ) ? (
                !isMobile ? (
                    <div className={classes.subMenuContainer}>
                        <SubMenuButton
                            pathname={branch}
                            route={'/manageroles'}
                            name={'Department Roles'}
                        />
                        {userrole === 'Super Admin' ? (
                            <>
                                <SubMenuButton
                                    pathname={branch}
                                    route={'/auditalldeptroles'}
                                    name={'Audit Roles'}
                                />
                                <SubMenuButton
                                    pathname={branch}
                                    route={'/superadminroles'}
                                    name={'Super Admin Roles'}
                                />
                            </>
                        ) : null}
                    </div>
                ) : null
            ) : null
            break
        default:
            component = (
                <div className={classes.subMenuButton}>Invalid option</div>
            )
    }

    return (
        <>
            <ToolBar
                className={clsx(
                    classes.toolBar,
                    component && classes.toolBarOpen
                )}
            >
                {component}
            </ToolBar>
        </>
    )
}

export default SubMenu
